export const TRANSFER_OPTIONS_BUTTON_LABEL = 'Toggle transfer options';

export const TRANSFER_OPTIONS_BUTTON_TEST_ID = 'transfer-options-button';
